import { render, staticRenderFns } from "./Welfare.vue?vue&type=template&id=54a3c171&scoped=true&"
import script from "./Welfare.vue?vue&type=script&lang=js&"
export * from "./Welfare.vue?vue&type=script&lang=js&"
import style0 from "./Welfare.vue?vue&type=style&index=0&id=54a3c171&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a3c171",
  null
  
)

export default component.exports